export default function Datenschutz() {
  return (
    <section id="datenschutz" className="py-20 bg-gray-50 border-t border-gray-100">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-10">
          <span className="inline-flex items-center rounded-full bg-white px-4 py-1.5 text-sm font-medium text-slate-700 border border-slate-200">
            Privacy
          </span>
          <h2 className="mt-4 text-3xl md:text-4xl font-bold text-brand-blue">
            Datenschutzerklärung
          </h2>
          <p className="mt-3 text-gray-600 max-w-3xl">
            Informationen zur Verarbeitung personenbezogener Daten auf dieser Website.
          </p>
        </div>

        <div className="rounded-3xl border border-gray-200 bg-white shadow-sm p-8 md:p-10 space-y-10">
          <div>
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              1. Verantwortlicher
            </h3>
            <div className="text-sm text-gray-700 leading-7">
              <p>FUM DA HANDELS GMBH</p>
              <p>Wöhlerstraße 8</p>
              <p>22113 Hamburg</p>
              <p>Deutschland</p>
              <p>
                E-Mail:{" "}
                <a href="mailto:info@fumda.de" className="text-brand-blue hover:underline">
                  info@fumda.de
                </a>
              </p>
              <p>
                Telefon:{" "}
                <a href="tel:+49407310510" className="text-brand-blue hover:underline">
                  +49 40 7310510
                </a>
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              2. Allgemeine Hinweise zur Datenverarbeitung
            </h3>
            <p className="text-sm text-gray-700 leading-7">
              Der Schutz Ihrer personenbezogenen Daten ist uns wichtig. Wir
              verarbeiten personenbezogene Daten ausschließlich im Rahmen der
              geltenden gesetzlichen Datenschutzvorschriften, insbesondere der
              Datenschutz-Grundverordnung (DSGVO).
            </p>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              3. Aufruf der Website
            </h3>
            <p className="text-sm text-gray-700 leading-7">
              Beim Besuch dieser Website können technisch erforderliche Daten
              verarbeitet werden, um die Website bereitzustellen, die Stabilität
              und Sicherheit zu gewährleisten und die Auslieferung der Inhalte zu
              ermöglichen. Hierzu können insbesondere IP-Adresse, Datum und Uhrzeit
              des Zugriffs, Browsertyp, Betriebssystem, Referrer-URL und aufgerufene
              Seiten gehören.
            </p>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              4. Kontaktaufnahme
            </h3>
            <p className="text-sm text-gray-700 leading-7">
              Wenn Sie uns per E-Mail oder über ein Kontaktformular kontaktieren,
              verarbeiten wir die von Ihnen übermittelten Angaben ausschließlich
              zur Bearbeitung Ihrer Anfrage und für die damit verbundene
              Kommunikation. Die Verarbeitung erfolgt zur Durchführung
              vorvertraglicher Maßnahmen, zur Vertragserfüllung oder auf Grundlage
              unseres berechtigten Interesses an einer ordnungsgemäßen Bearbeitung
              von Kontaktanfragen.
            </p>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              5. Speicherdauer
            </h3>
            <p className="text-sm text-gray-700 leading-7">
              Personenbezogene Daten werden nur so lange gespeichert, wie dies
              für die jeweiligen Zwecke erforderlich ist oder gesetzliche
              Aufbewahrungspflichten bestehen. Sobald der Zweck der Verarbeitung
              entfällt und keine gesetzlichen Pflichten entgegenstehen, werden
              die Daten gelöscht.
            </p>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              6. Ihre Rechte
            </h3>
            <div className="text-sm text-gray-700 leading-7 space-y-3">
              <p>
                Sie haben nach Maßgabe der gesetzlichen Vorschriften das Recht
                auf Auskunft über die zu Ihrer Person gespeicherten Daten.
              </p>
              <p>
                Außerdem haben Sie das Recht auf Berichtigung unrichtiger Daten,
                auf Löschung, auf Einschränkung der Verarbeitung und auf
                Datenübertragbarkeit.
              </p>
              <p>
                Sofern eine Verarbeitung auf Grundlage eines berechtigten
                Interesses erfolgt, können Sie aus Gründen, die sich aus Ihrer
                besonderen Situation ergeben, Widerspruch gegen die Verarbeitung
                einlegen.
              </p>
              <p>
                Wenn Sie der Ansicht sind, dass die Verarbeitung Ihrer Daten gegen
                Datenschutzrecht verstößt, haben Sie zudem das Recht auf
                Beschwerde bei einer Datenschutzaufsichtsbehörde.
              </p>
            </div>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              7. Externe Inhalte und Dienste
            </h3>
            <p className="text-sm text-gray-700 leading-7">
              Sofern auf dieser Website externe Inhalte oder Dienste eingebunden
              werden, etwa Karten, Videos, Schriftarten, Analyse-Tools oder
              sonstige Drittanbieter-Komponenten, informieren wir an geeigneter
              Stelle gesondert über Art, Umfang und Zweck der jeweiligen
              Datenverarbeitung.
            </p>
          </div>

          <div className="border-t border-gray-200 pt-8">
            <h3 className="text-xl font-semibold text-slate-900 mb-3">
              8. Aktualität
            </h3>
            <p className="text-sm text-gray-700 leading-7">
              Diese Datenschutzerklärung wird bei Bedarf angepasst, damit sie
              den aktuellen rechtlichen Anforderungen und den tatsächlichen
              Verarbeitungsprozessen auf dieser Website entspricht.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
